var map = {
	"./Featuresicon1.png": 9906,
	"./Featuresicon2.png": 6641,
	"./Featuresicon3.png": 9719,
	"./Featuresicon4.png": 7591,
	"./Featuresicon5.png": 6401,
	"./Featuresicon6.png": 4555
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6070;